import { AxiosResponse } from 'axios';
import { api as companiesApi } from 'services/companiesApi';

export const getJobProfileById = async (id: string): Promise<AxiosResponse> => {
	return await companiesApi.get(`/job-profiles/${id}`);
};

export const getJobProfileRisksById = async (
	id: string,
	riskId: string,
): Promise<AxiosResponse> => {
	return await companiesApi.get(`/job-profiles/${id}/risks/${riskId}`);
};

export const putJobProfileRisksById = async (
	id: string,
	payload: any,
): Promise<AxiosResponse> => {
	return await companiesApi.put(
		`/job-profiles/${id}/risks/${payload.riskId}`,
		payload,
	);
};

export const getExamSynonyms = async (name: string): Promise<AxiosResponse> => {
	return await companiesApi.get(`/exams/synonyms`, {
		params: {
			name,
		},
	});
};
